@if (expirationTooltipKey(); as key) {
  <i
    class="fa-solid {{ iconClass() }}"
    role="img"
    tooltipPosition="top"
    showDelay="500"
    [pTooltip]="key | translate: daysToExpiration()"
    [attr.aria-label]="key | translate: daysToExpiration()"
  ></i>
}
